import React, { useState } from 'react'
import { Box, Alert, Heading, Text, Button } from '@chakra-ui/react'

import FormField from '../../includes/FormField'
import FileChooser from '../../includes/FileChooser'

const Sponsor = ({ trial, fields, data, updateData }) => {
  const [logoUrl, setLogoUrl] = useState(trial?.sponsorLogoUrl)

  return (
    <Box>
      <Box rounded='md' shadow='md' bg='gray.50' borderWidth='1px' p={3}>
        <Heading as='h3' size='md'>Trial sponsor</Heading>
        <Text>If this is set, the name of the trial sponsor will be displayed instead of the team name on the participant portal and app.</Text>

        <Box mt={5}>
          {fields.map(field =>
            <FormField key={field.name} label={field.label} type={field.type} value={data[field.key]} onChange={e => updateData({ [field.key]: e.target.value })} />
          )}
        </Box>

        <Heading as='h4' size='sm' mt={5}>Logo</Heading>
        <Text color='gray.700'>Upload a logo for the trial sponsor. This logo will be shown to participants in place of the team's logo.</Text>
        {logoUrl
          ? <img src={logoUrl} style={{ width: 200, marginTop: 15 }} />
          : <Alert mt={5} variant='left-accent'>No logo is currently set.</Alert>}
        <Box display='flex' mt={5}>
          <FileChooser
            accept='image/*'
            forType='trial' forObject={trial}
            onComplete={({ storedName, expectedUrl }) => {
              updateData({ sponsorLogo: storedName })
              setLogoUrl(expectedUrl)
            }}
            trigger={<Button colorScheme='primary'>Update logo</Button>}
          />
          <Button
            ml={2} onClick={e => {
              updateData({ sponsorLogo: null })
              setLogoUrl(null)
            }}
          >Remove logo
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Sponsor
